import { Link } from 'react-router-dom';

import { List } from 'lucide-react';
import { DefaultTooltip } from 'twyne-new.ui';

export default function transactionsAction(info) {
  return <TransactionsAction info={info} />
}

function TransactionsAction({ info }) {
  const { allocationId, subidKey, status } = info.row.original
  const disabled = status === 'disabled'

  if (disabled) {
    return <div className='opacity-40'>
      <List size={16} />
    </div>
  }

  return <DefaultTooltip content='Show transactions'>
    <Link to={{ pathname: `/offer/allocations/${allocationId}/transactions`, state: { subId: subidKey } }}>
      <List size={16} />
    </Link>
  </DefaultTooltip>
}
